export const CONTACTUS_SUBMIT_SUCCESS = "CONTACTUS_SUBMIT_SUCCESS";
export const CONTACTUS_SUBMIT_FAILURE = "CONTACTUS_SUBMIT_FAILURE";
export const CONTACTUS_SUBMIT_INPROGRESS = "CONTACTUS_SUBMIT_INPROGRESS";
export const CLEAR_CONTACTUS_MESSAGE = "CLEAR_CONTACTUS_MESSAGE";
